// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconFilesFileCzi_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.0001 0L18.0001 6H12.0001V0Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18 24H0L6.01609e-05 1.90735e-06H10V2L2.00006 2L2.00006 10H16V8H18V10H24V20H18V24ZM16 20H2.00006V22L16 22V20ZM10.4609 17.8008C10.052 17.9987 9.51817 18.0977 8.85932 18.0977C7.99994 18.0977 7.32416 17.8451 6.83197 17.3398C6.33978 16.8346 6.09369 16.1615 6.09369 15.3203C6.09369 14.4245 6.36973 13.6979 6.92182 13.1406C7.4765 12.5833 8.19525 12.3047 9.07807 12.3047C9.62494 12.3047 10.0859 12.3737 10.4609 12.5117V13.7266C10.0859 13.5026 9.6588 13.3906 9.17963 13.3906C8.65359 13.3906 8.22911 13.556 7.90619 13.8867C7.58327 14.2174 7.42182 14.6654 7.42182 15.2305C7.42182 15.7721 7.57416 16.2044 7.87885 16.5273C8.18353 16.8477 8.59369 17.0078 9.10932 17.0078C9.6015 17.0078 10.052 16.888 10.4609 16.6484V17.8008ZM15.4687 18H10.957V17.2734L13.8281 13.4258H11.164V12.3984H15.4609V13.1055L12.6523 16.9766H15.4687V18ZM16.2968 18H17.5585V12.3984H16.2968V18Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H14V2H2V13H22V10H24V13H32V27H24V32H0V0ZM2 30V27H22V30H2ZM14.2686 22.7759C13.8086 22.9985 13.208 23.1099 12.4668 23.1099C11.5 23.1099 10.7397 22.8257 10.186 22.2573C9.63232 21.689 9.35547 20.9316 9.35547 19.9854C9.35547 18.9775 9.66602 18.1602 10.2871 17.5332C10.9111 16.9062 11.7197 16.5928 12.7129 16.5928C13.3281 16.5928 13.8467 16.6704 14.2686 16.8257V18.1924C13.8467 17.9404 13.3662 17.8145 12.8271 17.8145C12.2354 17.8145 11.7578 18.0005 11.3945 18.3726C11.0312 18.7446 10.8496 19.2485 10.8496 19.8843C10.8496 20.4937 11.021 20.98 11.3638 21.3433C11.7065 21.7036 12.168 21.8838 12.748 21.8838C13.3018 21.8838 13.8086 21.749 14.2686 21.4795V22.7759ZM19.9023 23H14.8267V22.1826L18.0566 17.854H15.0596V16.6982H19.8936V17.4937L16.7339 21.8486H19.9023V23ZM20.834 23H22.2534V16.6982H20.834V23Z" class="svg-bg"/>
  <path d="M24 8L16 0V8H24Z" class="svg-bg"/>
</svg>
`;
/**
 * IconFilesFileCzi is a generated icon component.
 */
let IconFilesFileCzi = IconFilesFileCzi_1 = class IconFilesFileCzi extends IconBaseElement {
    render() {
        return html `${IconFilesFileCzi_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconFilesFileCzi.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconFilesFileCzi = IconFilesFileCzi_1 = __decorate([
    customElement('zui-icon-files-file-czi')
], IconFilesFileCzi);
export { IconFilesFileCzi };
